"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartDrawerHeader = void 0;
const base_component_1 = require("../../components/base-component");
const dom_1 = require("../../utils/dom");
const utils_1 = require("../../utils/utils");
const CART_DRAWER_SELECTOR = 'cart-drawer';
const CART_DRAWER_HEADER_SELECTOR = 'cart-drawer-header';
class CartDrawerHeader extends base_component_1.BaseComponent {
    mountComponent() {
        const cartDrawer = (0, utils_1.$elParent)(CART_DRAWER_SELECTOR, this);
        cartDrawer?.on('update-nodes', this.handleCartDrawerUpdate);
    }
    unmountComponent() {
        const cartDrawer = (0, utils_1.$elParent)(CART_DRAWER_SELECTOR, this);
        cartDrawer?.off('update-nodes', this.handleCartDrawerUpdate);
    }
    handleCartDrawerUpdate = ({ node }) => {
        (0, dom_1.replaceNodeChildren)(this, (0, utils_1.$el)(CART_DRAWER_HEADER_SELECTOR, node));
    };
}
exports.CartDrawerHeader = CartDrawerHeader;
